import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { ClienteAlbaranApiService } from 'src/app/service/api/tablas-maestras-api.service';
import { BaseForm } from 'src/app/view/base-form';
import { ClienteAlbaranModel } from 'src/app/models/ventas/tablas-maestras.model';
import { ClienteFormDefinition } from './form-control/form-definition';

@Component({
  selector: 'app-formulario-pulverizacion',
  standalone: false,
  templateUrl: './cliente-form.component.html',
  styleUrls: ['./cliente-form.component.scss'],
})
export class ClienteAlbaranFormComponent extends BaseForm<ClienteAlbaranModel> implements OnInit {
  public form!: ClienteFormDefinition;
  public override model: ClienteAlbaranModel = {};
  public reactiveFormRecordId = '';

  public getRequest!: RequestHandler<ClienteAlbaranModel[]>;

  constructor(
    public override route: ActivatedRoute,
    public override dashboard: DashboardService,
    public override router: Router,
    public clientesApi: ClienteAlbaranApiService,
  ) {
    super(
      route,
      router,
      dashboard,
      clientesApi.clientePUT,
      clientesApi.clientePOST,
      'clientes',
      'Actualizar Cliente',
      'Generar Cliente',
      'Duplicar Cliente',
    );

    this.getRequest = this.clientesApi.clienteGET;
  }

  public ngOnInit(): void {
    this.softInit(this.getType());
    const routeModel = this.getModel() as Partial<ClienteAlbaranModel>;

    this.reactiveFormRecordId = this.resolveReactiveFormRecordId(routeModel);
    this.form = new ClienteFormDefinition(
      this.getType(),
      this.initializeHostModel({ ...this.model, ...routeModel } as ClienteAlbaranModel),
    );
  }
}
